export function formatDateSensor(data) {
  var formtDate = {};
  for (const sensor in data) {
    if (Array.isArray(data[sensor].valores)) {
      formtDate[sensor] = {
        data: data[sensor].valores.map((valor, index) => ({
          date: data[sensor].dataDaColeta[index],
          value: valor,
        })),
        group: sensor === "ECG" && data["BPM"],
      };
    } else if (sensor !== "BPM") {
      formtDate[sensor] = {
        data: [
          {
            date: data[sensor].dataDaColeta,
            value: data[sensor].valores,
          },
        ],
      };
    }
  }
  return formtDate;
}
export function isCheckData(data) {
  const response = {};
  for (let key in data) {
    if (Array.isArray(data[key].valores)) {
      if (data[key].valores.length > 0) {
        response[key] = data[key];
      }
    } else if (
      data[key].valores !== null &&
      data[key].valores !== "" &&
      data[key].valores !== undefined
    ) {
      response[key] = data[key];
    }
  }
  return response;
}

export const bgColors = {
  warning: "#FC8618",
  normal: "#3AB238",
  alerta: "#DC3545",
};

export const dataColor = [
  {
    id: "#696969",
    label: "Cinza",
  },
  {
    id: "#FC8618",
    label: "Laranja",
  },
  {
    id: "#3AB238",
    label: "Verde",
  },
  {
    id: "#DC3545",
    label: "Vermelho",
  },
  {
    id: "#1E729F",
    label: "Azul",
  },
];

export function classifyBPM(value) {
  if (value <= 40) {
    return "alerta";
  } else if (value < 60) {
    return "warning";
  } else if (value <= 100) {
    return "normal";
  } else if (value < 120) {
    return "warning";
  } else {
    return "alerta";
  }
}
export const labelStatus = {
  warning: "Alerta",
  normal: "Normal",
  alerta: "Crítico",
};
export function classifySPO2(value) {
  if (value <= 90) {
    return "alerta";
  } else if (value < 95) {
    return "warning";
  } else {
    return "normal";
  }
}

export function getNameSensor(value) {
  switch (value) {
    case "SPO2":
      return "SPO2";
    default:
      return "";
  }
}

export function getStatus(sensor, value) {
  switch (sensor) {
    case "ECG":
      return classifyBPM(value);
    case "SPO2":
      return classifySPO2(value);
    case "BPM":
      return classifyBPM(value);
    default:
      return "normal";
  }
}
